export enum TargetGroupingTypes {
	Company = 1,
	Team = 2,
}
